//
// Copyright 2021 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/client/services.proto (package dxos.client.services, syntax proto3)
/* eslint-disable */

// TODO(burdon): Reorganize packages (e.g., client.services, echo.database).

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Invitation, SpaceState } from "./invitation_pb.js";
import { file_dxos_client_invitation } from "./invitation_pb.js";
import type { SwarmInfo } from "../devtools/swarm_pb.js";
import { file_dxos_devtools_swarm } from "../devtools/swarm_pb.js";
import type { EdgeReplicationSetting } from "../echo/metadata_pb.js";
import { file_dxos_echo_metadata } from "../echo/metadata_pb.js";
import type { TimeframeVector } from "../echo/timeframe_pb.js";
import { file_dxos_echo_timeframe } from "../echo/timeframe_pb.js";
import type { Error } from "../error_pb.js";
import { file_dxos_error } from "../error_pb.js";
import type { Credential, DeviceProfileDocument, MembershipPolicy, ProfileDocument, SpaceMember_Role } from "../halo/credentials_pb.js";
import { file_dxos_halo_credentials } from "../halo/credentials_pb.js";
import type { PublicKey } from "../keys_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import type { SignalState } from "../mesh/signal_pb.js";
import { file_dxos_mesh_signal } from "../mesh/signal_pb.js";
import type { PeerState } from "../mesh/presence_pb.js";
import { file_dxos_mesh_presence } from "../mesh/presence_pb.js";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/client/services.proto.
 */
export const file_dxos_client_services: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_dxos_client_invitation, file_dxos_devtools_swarm, file_dxos_echo_metadata, file_dxos_echo_timeframe, file_dxos_error, file_dxos_halo_credentials, file_dxos_keys, file_dxos_mesh_signal, file_dxos_mesh_presence]);

/**
 * @generated from message dxos.client.services.Platform
 */
export type Platform = Message<"dxos.client.services.Platform"> & {
  /**
   * @generated from field: dxos.client.services.Platform.PLATFORM_TYPE type = 1;
   */
  type: Platform_PLATFORM_TYPE;

  /**
   * / The User-Agent string from a browser
   *
   * @generated from field: optional string user_agent = 2;
   */
  userAgent?: string;

  /**
   * / e.g process.platform from node, e.g. 'darwin', 'linux', 'win32'
   *
   * @generated from field: optional string platform = 3;
   */
  platform?: string;

  /**
   * / the Node.JS arch string, e.g. 'arm64', 'x64'
   *
   * @generated from field: optional string arch = 4;
   */
  arch?: string;

  /**
   * / the node.js version string
   *
   * @generated from field: optional string runtime = 5;
   */
  runtime?: string;

  /**
   * TODO(nf): uint64? :)
   * / the number of seconds the client has been up
   *
   * @generated from field: optional uint32 uptime = 6;
   */
  uptime?: number;

  /**
   * / e.g. NodeJS.MemoryUsage, subject to change
   *
   * @generated from field: optional google.protobuf.Struct memory = 7;
   */
  memory?: JsonObject;
};

/**
 * Describes the message dxos.client.services.Platform.
 * Use `create(PlatformSchema)` to create a new message.
 */
export const PlatformSchema: GenMessage<Platform> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 0);

/**
 * @generated from enum dxos.client.services.Platform.PLATFORM_TYPE
 */
export enum Platform_PLATFORM_TYPE {
  /**
   * @generated from enum value: BROWSER = 0;
   */
  BROWSER = 0,

  /**
   * / @deprecated The shared-worker services path was removed. Value reserved for wire compatibility.
   *
   * @generated from enum value: SHARED_WORKER = 1;
   */
  SHARED_WORKER = 1,

  /**
   * @generated from enum value: NODE = 2;
   */
  NODE = 2,

  /**
   * @generated from enum value: DEDICATED_WORKER = 3;
   */
  DEDICATED_WORKER = 3,
}

/**
 * Describes the enum dxos.client.services.Platform.PLATFORM_TYPE.
 */
export const Platform_PLATFORM_TYPESchema: GenEnum<Platform_PLATFORM_TYPE> = /*@__PURE__*/
  enumDesc(file_dxos_client_services, 0, 0);

/**
 * @generated from message dxos.client.services.Identity
 */
export type Identity = Message<"dxos.client.services.Identity"> & {
  /**
   * @generated from field: string did = 4;
   */
  did: string;

  /**
   * @generated from field: dxos.keys.PublicKey identity_key = 1;
   */
  identityKey?: PublicKey;

  /**
   * @generated from field: optional dxos.keys.PublicKey space_key = 2;
   */
  spaceKey?: PublicKey;

  /**
   * @generated from field: optional dxos.halo.credentials.ProfileDocument profile = 3;
   */
  profile?: ProfileDocument;
};

/**
 * Describes the message dxos.client.services.Identity.
 * Use `create(IdentitySchema)` to create a new message.
 */
export const IdentitySchema: GenMessage<Identity> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 1);

/**
 * @generated from message dxos.client.services.RecoverIdentityRequest
 */
export type RecoverIdentityRequest = Message<"dxos.client.services.RecoverIdentityRequest"> & {
  /**
   * @generated from oneof dxos.client.services.RecoverIdentityRequest.request
   */
  request: {
    /**
     * @generated from field: string recovery_code = 1;
     */
    value: string;
    case: "recoveryCode";
  } | {
    /**
     * @generated from field: dxos.client.services.RecoverIdentityRequest.ExternalSignature external = 2;
     */
    value: RecoverIdentityRequest_ExternalSignature;
    case: "external";
  } | {
    /**
     * @generated from field: string token = 3;
     */
    value: string;
    case: "token";
  } | {
    /**
     * / One-time proof minted by edge kms-service after a successful OAuth recovery flow.
     *
     * @generated from field: string recovery_proof = 4;
     */
    value: string;
    case: "recoveryProof";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message dxos.client.services.RecoverIdentityRequest.
 * Use `create(RecoverIdentityRequestSchema)` to create a new message.
 */
export const RecoverIdentityRequestSchema: GenMessage<RecoverIdentityRequest> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 2);

/**
 * @generated from message dxos.client.services.RecoverIdentityRequest.ExternalSignature
 */
export type RecoverIdentityRequest_ExternalSignature = Message<"dxos.client.services.RecoverIdentityRequest.ExternalSignature"> & {
  /**
   * @generated from field: dxos.keys.PublicKey lookup_key = 1;
   */
  lookupKey?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey device_key = 2;
   */
  deviceKey?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey control_feed_key = 3;
   */
  controlFeedKey?: PublicKey;

  /**
   * @generated from field: bytes signature = 4;
   */
  signature: Uint8Array;

  /**
   * These are required to verify the signature from the WebAuthn authenticator.
   *
   * @generated from field: optional bytes client_data_json = 5;
   */
  clientDataJson?: Uint8Array;

  /**
   * @generated from field: optional bytes authenticator_data = 6;
   */
  authenticatorData?: Uint8Array;
};

/**
 * Describes the message dxos.client.services.RecoverIdentityRequest.ExternalSignature.
 * Use `create(RecoverIdentityRequest_ExternalSignatureSchema)` to create a new message.
 */
export const RecoverIdentityRequest_ExternalSignatureSchema: GenMessage<RecoverIdentityRequest_ExternalSignature> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 2, 0);

/**
 * TODO(burdon): Preferences (in database).
 *
 * @generated from message dxos.client.services.Device
 */
export type Device = Message<"dxos.client.services.Device"> & {
  /**
   * @generated from field: dxos.keys.PublicKey device_key = 1;
   */
  deviceKey?: PublicKey;

  /**
   * @generated from field: dxos.client.services.DeviceKind kind = 2;
   */
  kind: DeviceKind;

  /**
   * @generated from field: optional dxos.halo.credentials.DeviceProfileDocument profile = 3;
   */
  profile?: DeviceProfileDocument;

  /**
   * @generated from field: dxos.client.services.Device.PresenceState presence = 4;
   */
  presence: Device_PresenceState;
};

/**
 * Describes the message dxos.client.services.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 3);

/**
 * TODO(nf): dedupe?
 *
 * @generated from enum dxos.client.services.Device.PresenceState
 */
export enum Device_PresenceState {
  /**
   * @generated from enum value: OFFLINE = 0;
   */
  OFFLINE = 0,

  /**
   * @generated from enum value: ONLINE = 1;
   */
  ONLINE = 1,

  /**
   * @generated from enum value: REMOVED = 2;
   */
  REMOVED = 2,
}

/**
 * Describes the enum dxos.client.services.Device.PresenceState.
 */
export const Device_PresenceStateSchema: GenEnum<Device_PresenceState> = /*@__PURE__*/
  enumDesc(file_dxos_client_services, 3, 0);

/**
 * @generated from message dxos.client.services.Contact
 */
export type Contact = Message<"dxos.client.services.Contact"> & {
  /**
   * @generated from field: dxos.keys.PublicKey identityKey = 2;
   */
  identityKey?: PublicKey;

  /**
   * @generated from field: optional dxos.halo.credentials.ProfileDocument profile = 1;
   */
  profile?: ProfileDocument;

  /**
   * @generated from field: repeated dxos.keys.PublicKey commonSpaces = 3;
   */
  commonSpaces: PublicKey[];

  /**
   * @generated from field: optional string did = 4;
   */
  did?: string;
};

/**
 * Describes the message dxos.client.services.Contact.
 * Use `create(ContactSchema)` to create a new message.
 */
export const ContactSchema: GenMessage<Contact> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 4);

/**
 * @generated from message dxos.client.services.ContactBook
 */
export type ContactBook = Message<"dxos.client.services.ContactBook"> & {
  /**
   * @generated from field: repeated dxos.client.services.Contact contacts = 1;
   */
  contacts: Contact[];
};

/**
 * Describes the message dxos.client.services.ContactBook.
 * Use `create(ContactBookSchema)` to create a new message.
 */
export const ContactBookSchema: GenMessage<ContactBook> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 5);

/**
 * @generated from message dxos.client.services.SpaceMember
 */
export type SpaceMember = Message<"dxos.client.services.SpaceMember"> & {
  /**
   * @generated from field: dxos.client.services.Identity identity = 1;
   */
  identity?: Identity;

  /**
   * @generated from field: dxos.client.services.SpaceMember.PresenceState presence = 2;
   */
  presence: SpaceMember_PresenceState;

  /**
   * @generated from field: repeated dxos.mesh.presence.PeerState peerStates = 3;
   */
  peerStates: PeerState[];

  /**
   * @generated from field: dxos.halo.credentials.SpaceMember.Role role = 4;
   */
  role: SpaceMember_Role;
};

/**
 * Describes the message dxos.client.services.SpaceMember.
 * Use `create(SpaceMemberSchema)` to create a new message.
 */
export const SpaceMemberSchema: GenMessage<SpaceMember> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 6);

/**
 * @generated from enum dxos.client.services.SpaceMember.PresenceState
 */
export enum SpaceMember_PresenceState {
  /**
   * @generated from enum value: OFFLINE = 0;
   */
  OFFLINE = 0,

  /**
   * @generated from enum value: ONLINE = 1;
   */
  ONLINE = 1,
}

/**
 * Describes the enum dxos.client.services.SpaceMember.PresenceState.
 */
export const SpaceMember_PresenceStateSchema: GenEnum<SpaceMember_PresenceState> = /*@__PURE__*/
  enumDesc(file_dxos_client_services, 6, 0);

/**
 * TODO(burdon): Rename SpaceInfo?
 *
 * @generated from message dxos.client.services.Space
 */
export type Space = Message<"dxos.client.services.Space"> & {
  /**
   * @generated from field: string id = 5;
   */
  id: string;

  /**
   * @generated from field: dxos.keys.PublicKey space_key = 1;
   */
  spaceKey?: PublicKey;

  /**
   * @generated from field: dxos.client.services.SpaceState state = 2;
   */
  state: SpaceState;

  /**
   * @generated from field: optional dxos.client.services.Space.PipelineState pipeline = 3;
   */
  pipeline?: Space_PipelineState;

  /**
   * @generated from field: optional dxos.error.Error error = 4;
   */
  error?: Error;

  /**
   * @generated from field: optional dxos.echo.metadata.EdgeReplicationSetting edge_replication = 6;
   */
  edgeReplication?: EdgeReplicationSetting;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * @generated from field: dxos.halo.credentials.MembershipPolicy membership_policy = 8;
   */
  membershipPolicy: MembershipPolicy;

  /**
   * @generated from field: repeated dxos.client.services.SpaceMember members = 10;
   */
  members: SpaceMember[];

  /**
   * @generated from field: optional dxos.keys.PublicKey creator = 11;
   */
  creator?: PublicKey;

  /**
   * / URL of the space root document this device has adopted; absent while the space is still on its control feed.
   *
   * @generated from field: optional string space_root_url = 12;
   */
  spaceRootUrl?: string;

  /**
   * @generated from field: dxos.client.services.Space.Metrics metrics = 21;
   */
  metrics?: Space_Metrics;
};

/**
 * Describes the message dxos.client.services.Space.
 * Use `create(SpaceSchema)` to create a new message.
 */
export const SpaceSchema: GenMessage<Space> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 7);

/**
 * @generated from message dxos.client.services.Space.Metrics
 */
export type Space_Metrics = Message<"dxos.client.services.Space.Metrics"> & {
  /**
   * @generated from field: optional google.protobuf.Timestamp open = 1;
   */
  open?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp pipeline_init_begin = 2;
   */
  pipelineInitBegin?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp control_pipeline_ready = 3;
   */
  controlPipelineReady?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp data_pipeline_open = 4;
   */
  dataPipelineOpen?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp data_pipeline_ready = 5;
   */
  dataPipelineReady?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp ready = 6;
   */
  ready?: Timestamp;
};

/**
 * Describes the message dxos.client.services.Space.Metrics.
 * Use `create(Space_MetricsSchema)` to create a new message.
 */
export const Space_MetricsSchema: GenMessage<Space_Metrics> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 7, 0);

/**
 * TODO(dmaretskyi): Consider merging with space metadata records.
 * TODO(dmaretskyi): ...or split into two separate pipeline messages.
 *
 * @generated from message dxos.client.services.Space.PipelineState
 */
export type Space_PipelineState = Message<"dxos.client.services.Space.PipelineState"> & {
  /**
   * @generated from field: optional dxos.keys.PublicKey control_feed_key = 1;
   */
  controlFeedKey?: PublicKey;

  /**
   * @generated from field: optional dxos.keys.PublicKey data_feed_key = 2;
   */
  dataFeedKey?: PublicKey;

  /**
   * / Remote feeds.
   * / TODO(burdon): Normalize _key suffix.
   *
   * @generated from field: repeated dxos.keys.PublicKey control_feeds = 18;
   */
  controlFeeds: PublicKey[];

  /**
   * @generated from field: repeated dxos.keys.PublicKey data_feeds = 19;
   */
  dataFeeds: PublicKey[];

  /**
   * / Last processed epoch. Might now have been applied yet.
   *
   * @generated from field: optional dxos.halo.credentials.Credential current_epoch = 20;
   */
  currentEpoch?: Credential;

  /**
   * / Epoch that is currently applied.
   *
   * @generated from field: optional dxos.halo.credentials.Credential applied_epoch = 21;
   */
  appliedEpoch?: Credential;

  /**
   * / Mutations already processed.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector current_control_timeframe = 10;
   */
  currentControlTimeframe?: TimeframeVector;

  /**
   * / Minimum timeframe to consider the state to be up-to-date.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector target_control_timeframe = 11;
   */
  targetControlTimeframe?: TimeframeVector;

  /**
   * / All mutations stored in feeds.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector total_control_timeframe = 14;
   */
  totalControlTimeframe?: TimeframeVector;

  /**
   * / All mutations known to exist on the network.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector known_control_timeframe = 15;
   */
  knownControlTimeframe?: TimeframeVector;

  /**
   * / Start timeframe of the pipeline.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector start_data_timeframe = 100;
   */
  startDataTimeframe?: TimeframeVector;

  /**
   * / Mutations already processed.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector current_data_timeframe = 12;
   */
  currentDataTimeframe?: TimeframeVector;

  /**
   * / Minimum timeframe to consider the state to be up-to-date.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector target_data_timeframe = 13;
   */
  targetDataTimeframe?: TimeframeVector;

  /**
   * / All mutations stored in feeds.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector total_data_timeframe = 16;
   */
  totalDataTimeframe?: TimeframeVector;

  /**
   * / All mutations known to exist on the network.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector known_data_timeframe = 17;
   */
  knownDataTimeframe?: TimeframeVector;

  /**
   * / URL of the space's automerge directory document.
   * / NOT the space root document — that is `SpaceMember.space_root_url`, a different document.
   *
   * @generated from field: optional string directory_url = 22;
   */
  directoryUrl?: string;
};

/**
 * Describes the message dxos.client.services.Space.PipelineState.
 * Use `create(Space_PipelineStateSchema)` to create a new message.
 */
export const Space_PipelineStateSchema: GenMessage<Space_PipelineState> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 7, 1);

/**
 * @generated from message dxos.client.services.QuerySpacesResponse
 */
export type QuerySpacesResponse = Message<"dxos.client.services.QuerySpacesResponse"> & {
  /**
   * @generated from field: repeated dxos.client.services.Space spaces = 1;
   */
  spaces: Space[];
};

/**
 * Describes the message dxos.client.services.QuerySpacesResponse.
 * Use `create(QuerySpacesResponseSchema)` to create a new message.
 */
export const QuerySpacesResponseSchema: GenMessage<QuerySpacesResponse> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 8);

/**
 * @generated from message dxos.client.services.CreateEpochResponse
 */
export type CreateEpochResponse = Message<"dxos.client.services.CreateEpochResponse"> & {
  /**
   * / Credential of the new epoch.
   *
   * @generated from field: optional dxos.halo.credentials.Credential epoch_credential = 1;
   */
  epochCredential?: Credential;

  /**
   * / Control pipeline timeframe.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector control_timeframe = 2;
   */
  controlTimeframe?: TimeframeVector;
};

/**
 * Describes the message dxos.client.services.CreateEpochResponse.
 * Use `create(CreateEpochResponseSchema)` to create a new message.
 */
export const CreateEpochResponseSchema: GenMessage<CreateEpochResponse> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 9);

/**
 * @generated from message dxos.client.services.ContactAdmission
 */
export type ContactAdmission = Message<"dxos.client.services.ContactAdmission"> & {
  /**
   * @generated from field: dxos.halo.credentials.Credential credential = 1;
   */
  credential?: Credential;
};

/**
 * Describes the message dxos.client.services.ContactAdmission.
 * Use `create(ContactAdmissionSchema)` to create a new message.
 */
export const ContactAdmissionSchema: GenMessage<ContactAdmission> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 10);

/**
 * @generated from message dxos.client.services.JoinSpaceResponse
 */
export type JoinSpaceResponse = Message<"dxos.client.services.JoinSpaceResponse"> & {
  /**
   * @generated from field: dxos.client.services.Space space = 1;
   */
  space?: Space;
};

/**
 * Describes the message dxos.client.services.JoinSpaceResponse.
 * Use `create(JoinSpaceResponseSchema)` to create a new message.
 */
export const JoinSpaceResponseSchema: GenMessage<JoinSpaceResponse> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 11);

/**
 * @generated from message dxos.client.services.InvitationMethod
 */
export type InvitationMethod = Message<"dxos.client.services.InvitationMethod"> & {
  /**
   * @generated from oneof dxos.client.services.InvitationMethod.kind
   */
  kind: {
    /**
     * @generated from field: dxos.client.services.Invitation created = 1;
     */
    value: Invitation;
    case: "created";
  } | {
    /**
     * @generated from field: dxos.client.services.Invitation accepted = 2;
     */
    value: Invitation;
    case: "accepted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message dxos.client.services.InvitationMethod.
 * Use `create(InvitationMethodSchema)` to create a new message.
 */
export const InvitationMethodSchema: GenMessage<InvitationMethod> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 12);

/**
 * @generated from message dxos.client.services.QueryInvitationsResponse
 */
export type QueryInvitationsResponse = Message<"dxos.client.services.QueryInvitationsResponse"> & {
  /**
   * @generated from field: dxos.client.services.QueryInvitationsResponse.Action action = 1;
   */
  action: QueryInvitationsResponse_Action;

  /**
   * @generated from field: dxos.client.services.QueryInvitationsResponse.Type type = 2;
   */
  type: QueryInvitationsResponse_Type;

  /**
   * @generated from field: repeated dxos.client.services.Invitation invitations = 3;
   */
  invitations: Invitation[];

  /**
   * indicate to caller that invitations of this action/type were existing at time of initial response.
   *
   * @generated from field: optional bool existing = 4;
   */
  existing?: boolean;
};

/**
 * Describes the message dxos.client.services.QueryInvitationsResponse.
 * Use `create(QueryInvitationsResponseSchema)` to create a new message.
 */
export const QueryInvitationsResponseSchema: GenMessage<QueryInvitationsResponse> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 13);

/**
 * @generated from enum dxos.client.services.QueryInvitationsResponse.Action
 */
export enum QueryInvitationsResponse_Action {
  /**
   * @generated from enum value: ADDED = 0;
   */
  ADDED = 0,

  /**
   * @generated from enum value: REMOVED = 1;
   */
  REMOVED = 1,

  /**
   * @generated from enum value: SAVED = 2;
   */
  SAVED = 2,

  /**
   * @generated from enum value: LOAD_COMPLETE = 3;
   */
  LOAD_COMPLETE = 3,
}

/**
 * Describes the enum dxos.client.services.QueryInvitationsResponse.Action.
 */
export const QueryInvitationsResponse_ActionSchema: GenEnum<QueryInvitationsResponse_Action> = /*@__PURE__*/
  enumDesc(file_dxos_client_services, 13, 0);

/**
 * @generated from enum dxos.client.services.QueryInvitationsResponse.Type
 */
export enum QueryInvitationsResponse_Type {
  /**
   * @generated from enum value: CREATED = 0;
   */
  CREATED = 0,

  /**
   * @generated from enum value: ACCEPTED = 1;
   */
  ACCEPTED = 1,
}

/**
 * Describes the enum dxos.client.services.QueryInvitationsResponse.Type.
 */
export const QueryInvitationsResponse_TypeSchema: GenEnum<QueryInvitationsResponse_Type> = /*@__PURE__*/
  enumDesc(file_dxos_client_services, 13, 1);

/**
 * Informational, consumers must share invitations to receive CancellableInvitation
 *
 * @generated from message dxos.client.services.LoadPersistentInvitationsResponse
 */
export type LoadPersistentInvitationsResponse = Message<"dxos.client.services.LoadPersistentInvitationsResponse"> & {
  /**
   * @generated from field: repeated dxos.client.services.Invitation invitations = 1;
   */
  invitations: Invitation[];
};

/**
 * Describes the message dxos.client.services.LoadPersistentInvitationsResponse.
 * Use `create(LoadPersistentInvitationsResponseSchema)` to create a new message.
 */
export const LoadPersistentInvitationsResponseSchema: GenMessage<LoadPersistentInvitationsResponse> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 14);

/**
 * @generated from message dxos.client.services.NetworkStatus
 */
export type NetworkStatus = Message<"dxos.client.services.NetworkStatus"> & {
  /**
   * @generated from field: dxos.client.services.ConnectionState swarm = 1;
   */
  swarm: ConnectionState;

  /**
   * @generated from field: repeated dxos.client.services.NetworkStatus.Signal signaling = 2;
   */
  signaling: NetworkStatus_Signal[];

  /**
   * @generated from field: repeated dxos.devtools.swarm.SwarmInfo connection_info = 3;
   */
  connectionInfo: SwarmInfo[];
};

/**
 * Describes the message dxos.client.services.NetworkStatus.
 * Use `create(NetworkStatusSchema)` to create a new message.
 */
export const NetworkStatusSchema: GenMessage<NetworkStatus> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 15);

/**
 * @generated from message dxos.client.services.NetworkStatus.Signal
 */
export type NetworkStatus_Signal = Message<"dxos.client.services.NetworkStatus.Signal"> & {
  /**
   * @generated from field: string server = 1;
   */
  server: string;

  /**
   * TODO(burdon): Where is this defined?
   *
   * @generated from field: dxos.mesh.signal.SignalState state = 2;
   */
  state: SignalState;
};

/**
 * Describes the message dxos.client.services.NetworkStatus.Signal.
 * Use `create(NetworkStatus_SignalSchema)` to create a new message.
 */
export const NetworkStatus_SignalSchema: GenMessage<NetworkStatus_Signal> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 15, 0);

/**
 * @generated from message dxos.client.services.EdgeStatus
 */
export type EdgeStatus = Message<"dxos.client.services.EdgeStatus"> & {
  /**
   * @generated from field: dxos.client.services.EdgeStatus.ConnectionState state = 1;
   */
  state: EdgeStatus_ConnectionState;

  /**
   * * Latency in ms 
   *
   * @generated from field: int32 rtt = 2;
   */
  rtt: number;

  /**
   * * How long the connection has been up 
   *
   * @generated from field: int32 uptime = 3;
   */
  uptime: number;

  /**
   * * Upload rate in bytes per second 
   *
   * @generated from field: int32 rate_bytes_up = 4;
   */
  rateBytesUp: number;

  /**
   * * Download rate in bytes per second 
   *
   * @generated from field: int32 rate_bytes_down = 5;
   */
  rateBytesDown: number;

  /**
   * @generated from field: int32 messages_sent = 6;
   */
  messagesSent: number;

  /**
   * @generated from field: int32 messages_received = 7;
   */
  messagesReceived: number;
};

/**
 * Describes the message dxos.client.services.EdgeStatus.
 * Use `create(EdgeStatusSchema)` to create a new message.
 */
export const EdgeStatusSchema: GenMessage<EdgeStatus> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 16);

/**
 * @generated from enum dxos.client.services.EdgeStatus.ConnectionState
 */
export enum EdgeStatus_ConnectionState {
  /**
   * @generated from enum value: NOT_CONNECTED = 0;
   */
  NOT_CONNECTED = 0,

  /**
   * @generated from enum value: CONNECTED = 1;
   */
  CONNECTED = 1,
}

/**
 * Describes the enum dxos.client.services.EdgeStatus.ConnectionState.
 */
export const EdgeStatus_ConnectionStateSchema: GenEnum<EdgeStatus_ConnectionState> = /*@__PURE__*/
  enumDesc(file_dxos_client_services, 16, 0);

/**
 * @generated from message dxos.client.services.QueryEdgeStatusResponse
 */
export type QueryEdgeStatusResponse = Message<"dxos.client.services.QueryEdgeStatusResponse"> & {
  /**
   * @generated from field: dxos.client.services.EdgeStatus status = 1;
   */
  status?: EdgeStatus;
};

/**
 * Describes the message dxos.client.services.QueryEdgeStatusResponse.
 * Use `create(QueryEdgeStatusResponseSchema)` to create a new message.
 */
export const QueryEdgeStatusResponseSchema: GenMessage<QueryEdgeStatusResponse> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 17);

/**
 * @generated from message dxos.client.services.QueryAgentStatusResponse
 */
export type QueryAgentStatusResponse = Message<"dxos.client.services.QueryAgentStatusResponse"> & {
  /**
   * @generated from field: dxos.client.services.QueryAgentStatusResponse.AgentStatus status = 1;
   */
  status: QueryAgentStatusResponse_AgentStatus;
};

/**
 * Describes the message dxos.client.services.QueryAgentStatusResponse.
 * Use `create(QueryAgentStatusResponseSchema)` to create a new message.
 */
export const QueryAgentStatusResponseSchema: GenMessage<QueryAgentStatusResponse> = /*@__PURE__*/
  messageDesc(file_dxos_client_services, 18);

/**
 * @generated from enum dxos.client.services.QueryAgentStatusResponse.AgentStatus
 */
export enum QueryAgentStatusResponse_AgentStatus {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: INACTIVE = 2;
   */
  INACTIVE = 2,

  /**
   * @generated from enum value: NOT_FOUND = 3;
   */
  NOT_FOUND = 3,
}

/**
 * Describes the enum dxos.client.services.QueryAgentStatusResponse.AgentStatus.
 */
export const QueryAgentStatusResponse_AgentStatusSchema: GenEnum<QueryAgentStatusResponse_AgentStatus> = /*@__PURE__*/
  enumDesc(file_dxos_client_services, 18, 0);

/**
 * @generated from enum dxos.client.services.SystemStatus
 */
export enum SystemStatus {
  /**
   * @generated from enum value: INACTIVE = 0;
   */
  INACTIVE = 0,

  /**
   * @generated from enum value: ACTIVE = 1;
   */
  ACTIVE = 1,
}

/**
 * Describes the enum dxos.client.services.SystemStatus.
 */
export const SystemStatusSchema: GenEnum<SystemStatus> = /*@__PURE__*/
  enumDesc(file_dxos_client_services, 0);

/**
 * @generated from enum dxos.client.services.DeviceKind
 */
export enum DeviceKind {
  /**
   * @generated from enum value: CURRENT = 0;
   */
  CURRENT = 0,

  /**
   * @generated from enum value: TRUSTED = 1;
   */
  TRUSTED = 1,
}

/**
 * Describes the enum dxos.client.services.DeviceKind.
 */
export const DeviceKindSchema: GenEnum<DeviceKind> = /*@__PURE__*/
  enumDesc(file_dxos_client_services, 1);

/**
 * TODO(wittjosiah): Rename to SwarnState?
 *
 * @generated from enum dxos.client.services.ConnectionState
 */
export enum ConnectionState {
  /**
   * @generated from enum value: OFFLINE = 0;
   */
  OFFLINE = 0,

  /**
   * @generated from enum value: ONLINE = 1;
   */
  ONLINE = 1,
}

/**
 * Describes the enum dxos.client.services.ConnectionState.
 */
export const ConnectionStateSchema: GenEnum<ConnectionState> = /*@__PURE__*/
  enumDesc(file_dxos_client_services, 2);

